import * as constants from "../constants";
import { DeliveryClient } from "@kentico/kontent-delivery";

const client = new DeliveryClient({ projectId: constants.PROJECT_ID });

export default client;
